import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-computer-science',
  imports: [PillarPagesTemp],
  templateUrl: './computer-science.html',
  styleUrl: './computer-science.scss',
})
export class ComputerScience {

}
